import { toast } from "react-toastify";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiConnector } from "../apiConnector";
import { endpoint } from "../apis";
import Cookies from "js-cookie";

// AsyncThunk to update user profile
export const updateUserProfile = createAsyncThunk(
  "user/updateUserProfile",
  async (userData, { rejectWithValue }) => {
    const token = Cookies.get("authToken");
    
    if (!token) {
      toast.error("Authentication token not found. Please log in again.");
      return rejectWithValue("Authentication token not found. Please log in again.");
    }
    
    try {
      // Create payload exactly as in successful Postman test
      const payload = {
        token: token,
        // city: userData.city,
        country_region: userData.region, // Send the full country name as country_region
        content_languages: userData.contentLanguages,
        primary_category: userData.primaryCategory,
        description: userData.bio,
        referral_source: userData.referralSource
      };
      
      // Add advanced profile data if provided
      if (userData.advancedData) {
        payload.secondary_categories = userData.advancedData.secondaryCategories || [];
        payload.years_of_experience = userData.advancedData.yearsOfExperience || '';
        payload.content_upload_frequency = userData.advancedData.uploadFrequency || '';
        payload.camera_setup = userData.advancedData.cameraSetup || '';
        payload.portfolio_url = userData.advancedData.portfolioLink || '';
        payload.target_audience_regions = userData.advancedData.targetRegions || [];
        payload.gst_tax_id = userData.advancedData.taxId || '';
        
        // Add new fields
        payload.audience_age_groups = userData.advancedData.audienceAgeGroups || [];
        payload.audience_gender_split = userData.advancedData.audienceGenderSplit || {};
        payload.speaking_languages = userData.advancedData.speakingLanguages || [];
        payload.collaboration_preferences = userData.advancedData.collaborationPreferences || [];
        payload.preferred_ad_types = userData.advancedData.preferredAdTypes || [];
        payload.preferred_budget_range = userData.advancedData.preferredBudgetRange || {};
        payload.past_collaborations = userData.advancedData.pastCollaborations || [];
        payload.availability_window = userData.advancedData.availabilityWindow || {};
        payload.creator_goals = userData.advancedData.creatorGoals || [];
      }
      
      
      
      // Send the payload directly without wrapping in input_json
      const response = await apiConnector(
        "post",
        endpoint.UPDATE_USER_PROFILE,
        payload,
        { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        null
      );

      toast.success("Profile updated successfully!");
      return response.data;
    } catch (error) {
      
      
      // Check if the error response indicates token expiration
      if (error?.response?.data == "('Token has been expired',)") {
        localStorage.clear();
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error.response?.data || "Failed to update profile!");
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// AsyncThunk to get user details
export const getUserDetails = createAsyncThunk(
  "user/getUserDetails",
  async (_, { rejectWithValue }) => {
    const token = Cookies.get("authToken");
    try {
      
      
      // Send the token directly without wrapping in input_json
      const response = await apiConnector(
        "post",
        endpoint.GET_USER_DETAILS,
        { token },
        { Authorization: `Bearer ${token}` },
        null
      );

      toast.success("User details fetched successfully!");
      return response.data;
    } catch (error) {
      
      // Check if the error response indicates token expiration
      if (error?.response?.data == "('Token has been expired',)") {
        localStorage.clear();
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error.response?.data || "Failed to fetch user details!");
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
